import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./plantAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk("plant/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const plantSlice = createSlice({
  name: "plant",
  initialState,
  reducers: { resetData: (state) => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const { resetData } = plantSlice.actions;

export const selectData = (state) => state.plant.value;
export const selectLoading = (state) => state.plant.loading;
export const selectError = (state) => state.plant.error;
export const selectPageNo = (state) => state.plant.pageNo;
export const selectPageSize = (state) => state.plant.pageSize;
export const selectTotalRecord = (state) => state.plant.totalRecord;

export default plantSlice.reducer;
